import { Box, Text } from '@mantine/core'
import { selectPolicies } from '@v2/domains/user/selectors/user.selectors'

import { AppointmentsByPersonRecordDto } from 'src/api/generated'
import dayjs from 'src/common/libs/dayjs'
import { STATUS_OPTIONS } from 'src/default/config'
import { useAppSelector } from 'src/v2/store/hooks'

import styles from '../AppointmentList/appointment-list.module.scss'
import { openManageAppointmentModal } from '../ManageAppointmentModal/openAppointmentModals'

//TODO any fix this in the refactor of appointment tools
interface AppointmentCardProps {
  appointment: AppointmentsByPersonRecordDto | any
  personId: string
}

const AppointmentCard = ({ appointment, personId }: AppointmentCardProps) => {
  const formatDate = (date: string | Date) => {
    return dayjs(date).tz().format('MMM D, YYYY, h:mm A')
  }

  const policies = useAppSelector(selectPolicies)

  const handleClick = () => {
    policies.includes('is_create_appointment_enabled')
      ? openManageAppointmentModal(personId, {
          ...appointment,
        })
      : null
  }

  const statusSelected = STATUS_OPTIONS.find(
    (option) => option.value === appointment.status,
  )

  return (
    <Box className={styles.appointmentCard} onClick={handleClick}>
      <Text pb="xs" className={styles.benefitType}>
        {appointment.benefitType.replaceAll('_', ' ')}
      </Text>

      <div className={styles.infoRow}>
        <Text className={styles.label}>Status:</Text>
        <Text className={styles.value}>{statusSelected?.label}</Text>
      </div>

      <div className={styles.infoRow}>
        <Text className={styles.label}>Date:</Text>
        <Text className={styles.value}>
          {formatDate(appointment.appointmentDate)}
        </Text>
      </div>

      <div className={styles.infoRow}>
        <Text className={styles.label}>Created By:</Text>
        <Text className={styles.value}>
          {appointment.createdBy !== ' '
            ? appointment.createdBy
            : 'Not Information'}
          <br />
          {formatDate(appointment.createdAt)}
        </Text>
      </div>

      <div className={styles.infoRow}>
        <Text className={styles.label}>Updated By:</Text>
        <Text className={styles.value}>
          {appointment.updatedBy !== ' '
            ? appointment.updatedBy
            : 'Not Information'}
          <br />
          {formatDate(appointment.updatedAt)}
        </Text>
      </div>
    </Box>
  )
}

export default AppointmentCard
